<template>
  <div style="display: inline">
    <el-form-item
      v-for="(formItem, formKey) in isHidden(formData)"
      :key="formKey"
      :label="formItem.label"
      :prop="parentKey + formKey + '.value'"
      :label-width="formItem.label ? defaultLabelWidth : ''"
      :rules="formItem.rules"
      v-bind="formItem.formItemProps"
      :style="{ padding: formItem.children ? 0 : null, margin: formItem.children ? 0 : null, marginBottom: 0 }"
    >
      <!-- 表单文本提示 -->
      <template
        v-if="formItem.labelTips"
        #label
      >
        {{ formItem.label }}
        <el-tooltip
          effect="dark"
          placement="bottom-start"
        >
          <div slot="content"><span v-html="formItem.labelTips" /></div>
          <i class="el-icon-question" />
        </el-tooltip>
      </template>
      <!-- 文本 -->
      <label
        v-if="formItem.type === 'label'"
        v-bind="getProps(formItem.props, formItem.type)"
        v-on="formItem.on ? formItem.on : {}"
      ><span v-html="formItem.value" /></label>
      <!-- 输入框 -->
      <el-input
        v-else-if="formItem.type === 'input'"
        v-model="formItem.value"
        v-bind="getProps(formItem.props, formItem.type)"
        v-on="formItem.on ? formItem.on : {}"
      >
        <template v-if="formItem.prepend" slot="prepend" v-bind="formItem.prepend?.props || {}">{{ formItem.prepend?.content }}</template>
        <template v-if="formItem.append" slot="append" v-bind="formItem.append?.props || {}">{{ formItem.append?.content }}</template>
      </el-input>
      <!-- 数字输入框 -->
      <el-input-number
        v-else-if="formItem.type === 'input-number'"
        v-model="formItem.value"
        v-bind="getProps(formItem.props, formItem.type)"
        v-on="formItem.on ? formItem.on : {}"
      />
      <!-- 选项树 -->
      <select-tree
        v-if="formItem.type === 'select-tree'"
        :key="formKey"
        :value="formItem.value"
        v-bind="getProps(formItem.props, formItem.type)"
        v-on="formItem.on ? formItem.on : {}"
      />
      <!-- 选项框 -->
      <sp-select
        v-else-if="formItem.type === 'select-v2'"
        v-model="formItem.value"
        v-bind="getProps(formItem.props, formItem.type)"
        :options="formItem.options"
        @change="selectChange(formItem)"
        v-on="formItem.on ? formItem.on : {}"
      />
      <el-select
        v-else-if="formItem.type === 'select'"
        v-model="formItem.value"
        v-bind="getProps(formItem.props, formItem.type)"
        @change="selectChange(formItem)"
        v-on="formItem.on ? formItem.on : {}"
      >
        <div
          v-if="formItem.isAll !== undefined"
          style="padding: 5px 20px"
        >
          <el-checkbox
            v-model="formItem.isAll"
            :indeterminate="formItem.isIndeterminate"
            @change="selectAllChange(formItem.isAll, formItem)"
          >
            全选
          </el-checkbox>
        </div>
        <div v-if="formItem.isGroup">
          <el-option-group
            v-for="group in formItem.options"
            :key="group.label"
            :label="group.label"
          >
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            />
          </el-option-group>
        </div>
        <div v-else>
          <el-option
            v-for="(item, index) in formItem.options"
            :key="index"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          />
        </div>
      </el-select>
      <!-- 级联选择框 -->
      <el-cascader
        v-else-if="formItem.type === 'cascader'"
        v-model="formItem.value"
        :options="formItem.options"
        v-bind="getProps(formItem.props, formItem.type)"
        v-on="formItem.on ? formItem.on : {}"
      />
      <!-- 日期选择器 -->
      <el-date-picker
        v-if="formItem.type === 'date-picker'"
        v-model="formItem.value"
        v-bind="getProps(formItem.props, formItem.type)"
        v-on="formItem.on ? formItem.on : {}"
      />
      <!-- 单选框 -->
      <el-radio-group
        v-else-if="formItem.type === 'radio-group'"
        v-model="formItem.value"
        v-bind="formItem.props"
        v-on="formItem.on ? formItem.on : {}"
      >
        <template v-if="formItem.isButton">
          <el-radio-button
            v-for="(item, index) in formItem.options"
            :key="index"
            :label="item.value"
            :disabled="formItem.disabled && isDisabled(formItem.value, item.value) || item.disabled"
          >
            {{ item.label }}
          </el-radio-button>
        </template>
        <template v-else-if="formItem.isBox">
          <div class="radio-group-container">
            <div v-if="formItem.title" class="title">
              {{ formItem.title }}
            </div>
            <div class="wrapper">
              <div v-if="!formItem.options.length" class="text-center">暂无数据</div>
              <div class="content">
                <el-radio
                  v-for="(item, index) in formItem.options"
                  :key="index"
                  class="radio-group-item"
                  :label="item.value"
                  :disabled="formItem.disabled && isDisabled(formItem.value, item.value) || item.disabled"
                  border
                >
                  {{ item.label }}
                </el-radio>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <el-radio
            v-for="(item, index) in formItem.options"
            :key="index"
            :label="item.value"
            :disabled="formItem.disabled && isDisabled(formItem.value, item.value) || item.disabled"
          >
            {{ item.label }}
          </el-radio>
        </template>
      </el-radio-group>
      <!-- 多选 -->
      <el-checkbox-group
        v-else-if="formItem.type === 'checkbox-group'"
        v-model="formItem.value"
        v-bind="formItem.props"
        v-on="formItem.on"
      >
        <template v-if="formItem.isButton">
          <el-checkbox-button
            v-for="(item, index) in formItem.options"
            :key="index"
            :label="item.value"
            :disabled="formItem.disabled && isDisabled(formItem.value, item.value) || item.disabled"
          >{{ item.label }}</el-checkbox-button>
        </template>
        <template v-else-if="formItem.isBox">
          <div class="checkbox-group-container">
            <div v-if="formItem.title" class="title">
              {{ formItem.title }}
            </div>
            <div class="content">
              <div v-if="!formItem.options.length" class="text-center">暂无数据</div>
              <el-checkbox
                v-for="(item, index) in formItem.options"
                :key="index"
                :label="item.value"
                :disabled="formItem.disabled && isDisabled(formItem.value, item.value) || item.disabled"
              >
                {{ item.label }}
                <el-tooltip effect="dark" placement="top-start">
                  <div slot="content">
                    <span v-html="item.tips" />
                  </div>
                  <i v-if="item.tips" class="el-icon-question" />
                </el-tooltip>
              </el-checkbox>
            </div>
          </div>
        </template>
        <template v-else>
          <el-checkbox
            v-for="(item, index) in formItem.options"
            :key="index"
            :label="item.value"
            :disabled="formItem.disabled && isDisabled(formItem.value, item.value) || item.disabled"
          >{{ item.label }}</el-checkbox>
        </template>
      </el-checkbox-group>
      <!-- 多选 -->
      <el-checkbox
        v-else-if="formItem.type === 'checkbox'"
        v-model="formItem.value"
        v-bind="formItem.props"
        v-on="formItem.on"
      />
      <!-- 开关 -->
      <el-switch
        v-else-if="formItem.type === 'switch'"
        v-model="formItem.value"
        v-bind="formItem.props"
        v-on="formItem.on"
      />
      <!-- 树结构 -->
      <tree-shuttle
        v-else-if="formItem.type === 'tree-shuttle'"
        v-model="formItem.value"
        :title="formItem.name"
        :init-data="formItem.options"
        v-bind="formItem.props"
        v-on="formItem.on"
      />
      <!-- 标签 -->
      <form-tags
        v-else-if="formItem.type === 'form-tags'"
        v-model="formItem.value"
        v-bind="formItem.props"
        v-on="formItem.on"
      />
      <!-- 范围 -->
      <form-range
        v-else-if="formItem.type === 'form-range'"
        v-model="formItem.value"
        v-bind="formItem.props"
      />
      <!-- 上传 -->
      <form-upload
        v-else-if="formItem.type === 'form-upload'"
        v-model="formItem.value"
        v-bind="formItem.props"
        @formItemValidateField="formItemValidateField(parentKey + formKey + '.value')"
      />
      <!-- 自定义插槽 -->
      <slot
        name="custom"
        v-bind="{
          form_item: formItem,
          form_key: formKey
        }"
      />
      <!-- 是否存在子级 -->
      <div
        v-if="formItem.children"
        class="w-full"
      >
        <base-form-item
          :default-label-width="defaultLabelWidth"
          :form-data="formItem.children"
          :parent-key="formKey ? parentKey + formKey + '.children.' : ''"
        >
          <template #custom="customProps">
            <slot name="custom" v-bind="customProps" />
          </template>
        </base-form-item>
      </div>
      <div v-if="formItem.formItemTips" v-bind="formItem.formItemTips?.props || {}">{{ formItem.formItemTips?.content }}</div>
    </el-form-item>
  </div>
</template>

<script>
export default {
  components: {
    'base-form-item': () => import('@/components/app-form-item'),
    'tree-shuttle': () => import('@/components/tree-shuttle'),
    'select-tree': () => import('@/components/select-tree'),
    'form-tags': () => import('@/components/form-tags'),
    'form-range': () => import('@/components/form-range'),
    'sp-select': () => import('@/components/sp-select'),
    'form-upload': () => import('@/components/form-upload'),
  },
  inject: {
    validateField: {
      from: 'validateField',
      default: () => {},
    },
  },
  props: {
    // 表单数据
    formData: {
      type: Object,
      required: true,
    },
    // 父级键值
    parentKey: {
      type: String,
      required: false,
      default: '',
    },
    // 默认文本宽度
    defaultLabelWidth: {
      type: String,
      required: false,
      default: '80px',
    },
  },
  data() {
    return {
      el_props: {
        'label': {
          style: {
            'word-wrap': 'break-word',
          },
        },
        'cascader': {
          placeholder: '请选择',
          style: 'width: 100%',
          clearable: true,
        },
        'select': {
          placeholder: '请选择',
          clearable: true,
          'collapse-tags': true,
        },
        'date-picker': {
          placeholder: '请选择',
          clearable: true,
        },
        'input': {
          placeholder: '请输入',
          clearable: true,
        },
        'input-number': {
          placeholder: '请输入',
          clearable: true,
        },
      },
    };
  },
  methods: {
    /**
     * 是否禁用按钮
     * @param {*} val 值
     * @param {*} check_val 绑定值
     */
    isDisabled: function(val, check_val) {
      return (typeof val === 'object' ? JSON.stringify(val) : val) !== (typeof check_val === 'object' ? JSON.stringify(check_val) : check_val);
    },

    /**
     * 是否隐藏
     * @param {*} obj
     */
    isHidden(obj) {
      const temp_obj = {};

      for (const key in obj){
        if (!obj[key].hidden) {
          temp_obj[key] = obj[key];
        }
      }
      return temp_obj;
    },

    /**
     * 选择框变化事件
     * @param formItem 表单项
     */
    selectChange(formItem) {
      // 不存在全选项或选项不存在时不执行以下代码
      if (formItem.isAll === undefined || formItem.options === undefined) {
        return;
      }

      // 判断是否全选
      if (formItem.value.length >= 0 && formItem.value.length < formItem.options.length) {
        formItem.isAll = false;
        formItem.isIndeterminate = formItem.value.length !== 0;
      } else {
        formItem.isIndeterminate = false;
        formItem.isAll = true;
      }
    },

    /**
     * 选择全选变化事件
     * @param isAll 是否全选
     * @param formItem 表单项
     */
    selectAllChange(isAll, formItem) {
      if (isAll) {
        formItem.value = formItem.options?.map(item => item.value);
      } else {
        formItem.value = [];
      }

      if (formItem.isIndeterminate) {
        formItem.isIndeterminate = false;
      }
    },

    // 获取props
    getProps: function(props, type) {
      let temp_props = this.el_props[type] ? this.el_props[type] : {};
      temp_props = { ...temp_props, ...props };

      return temp_props;
    },

    /**
     * 表单部分字段效验
     * @param {string} props 表单键
     * @returns {void}
     */
    formItemValidateField(props) {
      this.validateField(props);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item {
  padding: 9px 0;
  margin-bottom: 0;
}
.radio-group-container {
  border: 1px solid #e6ebf5;
  border-radius: 4px;
  .title {
    padding: 8px 16px;
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid #e6ebf5;
    background-color: #F5F7FA;
  }
  .wrapper {
    padding: 6px 11px;
    .content {
      display: flex;
      flex-wrap: wrap;
      .radio-group-item {
        flex: 1;
        margin: 10px 5px;
      }
    }
  }
}
.checkbox-group-container {
  border: 1px solid #e6ebf5;
  border-radius: 4px;
  .title {
    padding: 8px 16px;
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid #e6ebf5;
    background-color: #F5F7FA;
  }
  .content {
    padding: 16px;
  }
}
</style>
